import React, { useEffect,useState } from "react";
import "./Navbar.css";
import Logo from "../../../Assets/Images/brillJustLogo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getWalletBalance } from "../../../Redux/Actions/fetchWalletBalance";
import wallet from "../../../Assets/Images/wallet.svg";
import reload from "../../../Assets/Images/reload.svg";
import calciIcon from "../../../Assets/Images/calciIcon.svg"

const Navbar = (props) => {
  const { component, setComponentToRender, HanldeFormData } = props;
  const [isRotating, setIsRotating] = useState(false);

  // navigation
  const navigate = useNavigate();

  // navigation
  const dispatch = useDispatch();

  // loggedInStatus
  const isLoggedIn = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.isLoggedIn;
  });

  // userToken
  const userToken = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData?.token;
  });

  // getWalletData
  useEffect(() => {
    if(userToken){
      dispatch(getWalletBalance(userToken));
    }
  }, []);

  const fetchWalletBalance = async() => {
    setIsRotating(true);
   await dispatch(getWalletBalance(userToken));
   setTimeout(()=>{
    setIsRotating(false);
   },500)
   

  }
  const walletBalance = useSelector((state) => {
    return state?.getWalletData?.data?.data?.balance;
  });

  const navigateHome = () => {
    if (component) {
      navigate("/View-Plans");
      setComponentToRender("navbar");
      HanldeFormData("", "resetData");
    } else {
      if (isLoggedIn) {
        navigate("/View-Plans");
      } else {
        navigate("/");
      }
    }
  };

  return (
    <>
      <nav className="nav-container">
        <div className="nav-parent maxWidth ">
          <img
            src={Logo}
            className="bmi-logo"
            alt="bmi-logo"
            srcSet=""
            onClick={navigateHome}
          />
         
           <div className="GuideLines">
             <div>
            <Link to='/privacy-policy'>Privacy  Policy</Link>
          </div>
          <div>
            <p></p>
          </div>
          <div>
            <Link to='/Policy-Cancellation'>Refund Policy</Link>
          </div>
           <div>
            <Link to='/contact-us'>Contact Us</Link>
          </div>
           </div>
         
          

        {userToken && (
            <div className="btn-container-navbar refresh-icon">
            <button className="wallet-btn" onClick={fetchWalletBalance}>
              <div className="wallet-div">
                <img src={wallet} alt="wallet" />
              </div>
              ₹ {walletBalance}
              <img src={reload} alt="refresh" className={isRotating ? "rotate" : ""} />
            </button>
            {component}
          </div>
        )}
      </div>
    </nav >
    </>
  );
};

export default Navbar;
